import { useState } from "react"
import './Img.css'


const Img = ({ src, alt }) => {

    const [isLoading, setIsLoading] = useState(true)
    const handleImageLoad = () => {
        setIsLoading(false)
    }


    return (
        <div className="img-container">
            <img src={src} alt={alt} style={{ opacity: isLoading ? 0 : 1 }} onLoad={handleImageLoad} />
            {isLoading && (
                <div className="loading-img">
                    <div className="img-spinner"></div>
                </div>
            )}
        </div>

    )
}

export default Img